var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElectricity = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.852 13.443h.48v7.595l7.256-10.479h-4.37V2.956L5.961 13.443zM10.335 22a.96.96 0 0 1-.963-.962v-6.634H5.96a.96.96 0 0 1-.849-.513.96.96 0 0 1 .06-.995l7.256-10.48a.95.95 0 0 1 1.077-.371.96.96 0 0 1 .675.918v6.634h3.41a.96.96 0 0 1 .79 1.508l-7.256 10.48a.96.96 0 0 1-.788.415",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgElectricity);
export default ForwardRef;